// ** Initial State
const initialState = {
  registerData: null,
  failedRegisterMessage: null,
  userData: null,
  notifySuccessRegister: null,
  notifySuccessRegisterResendOtp: null,
  notifyFailedRegister: null,  
  notifySuccessRegisterVerifyOTP: null,
  notifyFailedRegisterVerifyOTP: null,
  notifySuccessForgotPassword: null,
  notifyFailedForgotPassword: null,
  notifySuccessResetPassword: null,
  notifyFailedResetPassword: null,
  notifySuccessUpdateProfile: null,
  notifyFailedUpdateProfile: null,
  notifySuccessUpdatePassword: null,
  notifyFailedUpdatePassword: null,
  account: null  
}

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SUCCESS_REGISTER':   
      return {
        ...state,
        registerData: action.registerData,
        notifySuccessRegister: true
      }
    case 'FAILED_REGISTER':
      return { 
        ...state,
        notifyFailedRegister: true,
        failedRegisterMessage: action.failedRegisterMessage
    }
    case 'CLEAR_REGISTER':
      return { 
        ...state,
        notifySuccessRegister: null,
        notifyFailedRegister: null
    }
    case 'SUCCESS_REGISTER_OTP_RESEND':
      return {
        ...state,
        registerData: action.registerData,
        notifySuccessRegisterResendOtp: true
      }
    case 'SUCCESS_REGISTER_OTP_VERIFY':
      return {
        ...state,
        userData: action.userData,
        notifySuccessRegisterVerifyOTP: true
      }
    case 'FAILED_REGISTER_OTP_VERIFY':
      return {
        ...state,        
        notifyFailedRegisterVerifyOTP: true
      }
    case 'CLEAR_REGISTER_OTP_VERIFY':
      return { 
        ...state,
        notifySuccessRegisterVerifyOTP: null,
        notifyFailedRegisterVerifyOTP: null
      }
    case 'SUCCESS_FORGOT_PASSWORD':
      return { 
        ...state,
        notifySuccessForgotPassword: true
      }
    case 'FAILED_FORGOT_PASSWORD':
      return { 
        ...state,
        notifyFailedForgotPassword: true
      }
    case 'CLEAR_FORGOT_PASSWORD':
    return { 
      ...state,
      notifySuccessForgotPassword: null,
      notifyFailedForgotPassword: null        
    }
    case 'SUCCESS_RESET_PASSWORD':
      return { 
        ...state,
        notifySuccessResetPassword: true
      }
    case 'FAILED_RESET_PASSWORD':
      return { 
        ...state,
        notifyFailedResetPassword: true
      }
    case 'CLEAR_RESET_PASSWORD':
      return { 
        ...state,
        notifySuccessResetPassword: null,
        notifyFailedResetPassword: null        
      }
    case 'SUCCESS_UPDATE_PROFILE':
      return { 
        ...state,
        notifySuccessUpdateProfile: true
      }
    case 'FAILED_UPDATE_PROFILE':
      return { 
        ...state,
        notifyFailedUpdateProfile: true
      }
    case 'CLEAR_UPDATE_PROFILE':
      return { 
        ...state,
        notifySuccessUpdateProfile: null,
        notifyFailedUpdateProfile: null
      }
    case 'SUCCESS_GET_PROFILE':
      return {
        ...state,
        account: action.account
      }
    case 'FAILED_GET_PROFILE':
      return state
      
    case 'SUCCESS_UPDATE_PASSWORD':
      return { 
        ...state,
        notifySuccessUpdatePassword: true
      }
    case 'FAILED_UPDATE_PASSWORD':
      return { 
        ...state,
        notifyFailedUpdatePassword: true
      }
    case 'CLEAR_UPDATE_PASSWORD':
        return { 
          ...state,
          notifySuccessUpdatePassword: null,
          notifyFailedUpdatePassword: null
        }   
    default:
      return state
  }
}

export default AuthReducer
